module.exports = __webpack_public_path__ + "img/zpt.asm.65286caf.jpg";